import { z } from 'zod/v3';

export const versionObjectResponse = z.object({
  version: z.string(),
});

export const versionResponse = z.union([z.string(), versionObjectResponse]);

export type VersionApi = {
  getVersion: () => Promise<VersionResponse>;
};

export type VersionResponse = z.infer<typeof versionResponse>;
